var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"billDetail"},[_c('CommonDetail',{attrs:{"type":"bill"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }